import React, { useState } from 'react';
import { Layout } from 'antd';
import { Routes, Route } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { useTheme } from '../../hooks/useTheme';
import Sidebar from './Sidebar/Sidebar';
import Header from './Header';
import Dashboard from '../Dashboard/Dashboard';
import {
  UsersList,
  UserUpsertPage,
  UserViewPage,
  ChangePasswordPage,
} from '../../pages/Users/routes';
import { UserActivitiesList } from '../../pages/UserActivities/routes';
import GlobalLoading from '../Utility/GlobalLoading';
import './Sidebar/Sidebar.css';
import NotificationsList from '../../pages/notifications/NotificationsList';
import NotificationUpsertPage from '../../pages/notifications/NotificationUpsertPage';
import NotificationViewPage from '../../pages/notifications/NotificationViewPage';
import RegionsList from '../../pages/region/RegionsList';
import RegionUpsertPage from '../../pages/region/RegionUpsertPage';
import ModalitiesList from '../../pages/Modalities/ModalitiesList';
import ModalityUpsertPage from '../../pages/Modalities/ModalityUpsertPage';
import EvaluationCriteriaList from '../../pages/EvaluationCriteria/EvaluationCriteriaList';
import EvaluationCriteriaUpsertPage from '../../pages/EvaluationCriteria/EvaluationCritieriaUpsertPage';
import SplashPage from '../../pages/Splash/SplashPage';
import CarouselPage from '../../pages/Carousel/CarouselPage';
import CompetitionUpsertPage from '../../pages/Competitions/CompetitionUpsertPage';
import CompetitionList from '../../pages/Competitions/CompetitionList';
import CompetitionVideosPage from '../../pages/Competitions/CompetitionVideosPage';
import EvaluationList from '../../pages/Evaluations/EvaluationList';
import RateVideoPage from '../../pages/Evaluations/RateVidePage';
import PlansList from '../../pages/Plans/PlansList';
import PlanUpsertPage from '../../pages/Plans/PlanUpsertPage';
import ClientSubscriptionList from '../../pages/ClientSubscriptions/ClientSubscriptionList';
import ClientSubscriptionViewPage from '../../pages/ClientSubscriptions/ClientSubscriptionViewPage';
import ParticipantList from '../../pages/Participants/ParticipantList';
import ParticipantUpsertPage from '../../pages/Participants/ParticipantUpsertPage';
import ParticipantViewPage from '../../pages/Participants/ParticipantViewPage';
import CompetitionWinnersList from '../../pages/CompetitionWinners/CompetitionWinnersList';
import CompetitionPreliminaryEvaluationList from '../../pages/CompetitionWinners/CompetitionPreliminaryEvaluationList';
import PreliminaryRateVideoPage from '../../pages/CompetitionWinners/PreliminaryRateVidePage';
import PreliminaryEvaluationList from '../../pages/CompetitionWinners/PreliminaryEvaluationList';
import CompetitionRankingList from '../../pages/CompetitionRanking/CompetitionRanking';
import CompetitionProgressList from '../../pages/CompetitionProgress/CompetitionProgressList';
import CompetitionJudgesList from '../../pages/CompetitionJudges/CompetitionJudgesList';
import AccessDenied from '../../pages/AccessDenied/AccessDenied';
import EvaluationHistoryList from '../../pages/EvaluationHistory/EvaluationHistoryList';
import CompetitionEvaluationsPage from '../../pages/CompetitionEvaluations/CompetitionEvaluationsPage';
import HeatmapReport from '../../pages/Reports/HeatmapReport';
import MarketInventoryReport from '../../pages/Reports/MarketInventoryReport';
import InterestsReport from '../../pages/Reports/InterestsReport';
import KitCheckReport from '../../pages/Reports/KitCheckReport';
import FavoriteTeamsReport from '../../pages/Reports/FavoriteTeamsReport';
import SalesReport from '../../pages/Reports/SalesReport';
import PlanAddonList from '../../pages/PlanAddons/PlanAddonList';
import PlanAddonUpsertPage from '../../pages/PlanAddons/PlanAddonUpsertPage';
import WinnersClaimList from '../../pages/PrizeClaims/WinnersClaimList';
import ClaimDetailView from '../../pages/PrizeClaims/ClaimDetailView';

const Admin = () => {
  const [collapsed, setCollapsed] = useState(false);
  const { loading } = useAuth();
  const { colors } = useTheme();

  if (loading) return <GlobalLoading />;

  const contentClassNames = collapsed
    ? 'sidebar--collapsed absolute t-0 r-0 sidebar'
    : 'sidebar absolute t-0 r-0 ';

  return (
    <Layout>
      <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      <div className={contentClassNames}>
        <Header />
        <main
          className="w-full"
          style={{
            backgroundColor: colors.background.main,
            minHeight: 'calc(100vh - 56px)',
          }}
        >
          <Routes>
            {/* Ruta por defecto: Dashboard */}
            <Route path="/" element={<Dashboard />} />
            <Route path="/dashboard" element={<Dashboard />} />

            {/* Rutas de Usuarios */}
            <Route path="/users/all" element={<UsersList />} />
            <Route path="/user-activity/all" element={<UserActivitiesList />} />
            <Route path="/users/add" element={<UserUpsertPage />} />
            <Route path="/users/:id/edit" element={<UserUpsertPage />} />
            <Route path="/users/view/:id" element={<UserViewPage />} />
            <Route
              path="/users/:id/change-password"
              element={<ChangePasswordPage />}
            />

            {/* Rutas de Configuraciones */}
            <Route path="/notifications/all" element={<NotificationsList />} />
            <Route
              path="/notifications/:id/edit"
              element={<NotificationUpsertPage />}
            />
            <Route
              path="/notifications/view/:id"
              element={<NotificationViewPage />}
            />

            {/* Rutas de Regiones */}
            <Route path="/regions/all" element={<RegionsList />} />
            <Route path="/regions/add" element={<RegionUpsertPage />} />
            <Route path="/regions/:id/edit" element={<RegionUpsertPage />} />

            {/* Rutas de Modalidades */}
            <Route path="/modalities/all" element={<ModalitiesList />} />
            <Route path="/modalities/add" element={<ModalityUpsertPage />} />
            <Route
              path="/modalities/:id/edit"
              element={<ModalityUpsertPage />}
            />

            {/* Rutas de Criterios de evaluación */}
            <Route
              path="/evaluation-criteria/all"
              element={<EvaluationCriteriaList />}
            />
            <Route
              path="/evaluation-criteria/add"
              element={<EvaluationCriteriaUpsertPage />}
            />
            <Route
              path="/evaluation-criteria/:id/edit"
              element={<EvaluationCriteriaUpsertPage />}
            />

            {/* Rutas de Splash */}
            <Route path="/splash" element={<SplashPage />} />

            {/* Rutas de Carousel */}
            <Route path="/carousel" element={<CarouselPage />} />

            {/* Rutas de Compentencia */}
            <Route path="/competitions/all" element={<CompetitionList />} />
            <Route
              path="/competitions/add"
              element={<CompetitionUpsertPage />}
            />
            <Route
              path="/competitions/:id/edit"
              element={<CompetitionUpsertPage />}
            />
            <Route
              path="/competitions/ranking/all"
              element={<CompetitionRankingList />}
            />
            <Route
              path="/competitions/videos"
              element={<CompetitionVideosPage />}
            />

            {/* Rutas de Evaluaciones */}
            <Route path="/evaluations/all" element={<EvaluationList />} />
            <Route path="/evaluations/:id/rate" element={<RateVideoPage />} />
            <Route
              path="/evaluations/preliminary/all"
              element={<CompetitionPreliminaryEvaluationList />}
            />
            <Route
              path="/evaluations/preliminary/:id/rate"
              element={<PreliminaryRateVideoPage />}
            />
            <Route
              path="/evaluations/preliminary/:id/evaluate"
              element={<PreliminaryEvaluationList />}
            />
            <Route
              path="/evaluations/progress/all"
              element={<CompetitionProgressList />}
            />
            <Route
              path="/evaluations/competitions/:id"
              element={<CompetitionJudgesList />}
            />
            <Route
              path="/evaluations/history/all"
              element={<EvaluationHistoryList />}
            />
            <Route
              path="/evaluations/history/:id/evaluations"
              element={<CompetitionEvaluationsPage />}
            />

            {/* Rutas de Planes */}
            <Route path="/memberships/all" element={<PlansList />} />
            <Route path="/memberships/:id/edit" element={<PlanUpsertPage />} />
            <Route path="/memberships/add" element={<PlanUpsertPage />} />

            {/* Rutas de Subscripciones */}
            <Route
              path="/subscriptions/all"
              element={<ClientSubscriptionList />}
            />
            <Route
              path="/subscriptions/:id/view"
              element={<ClientSubscriptionViewPage />}
            />

            {/* Rutas de participantes */}
            <Route path="/participants/all" element={<ParticipantList />} />
            <Route
              path="/participants/add"
              element={<ParticipantUpsertPage />}
            />
            <Route
              path="/participants/:id/edit"
              element={<ParticipantUpsertPage />}
            />
            <Route
              path="/participants/:id/view"
              element={<ParticipantViewPage />}
            />
            <Route
              path="/participants/winners/all"
              element={<CompetitionWinnersList />}
            />

            {/* Rutas de Reclamo de Premios */}
            <Route
              path="/prize-claims/winners"
              element={<WinnersClaimList />}
            />
            <Route
              path="/prize-claims/view/:id"
              element={<ClaimDetailView />}
            />

            {/* Ruta acceso denegado */}
            <Route path="/access-denied" element={<AccessDenied />} />

            {/* Rutas de Reportes */}
            <Route path="/reports/heatmap" element={<HeatmapReport />} />
            <Route
              path="/reports/market-inventory"
              element={<MarketInventoryReport />}
            />
            <Route path="/reports/interests" element={<InterestsReport />} />
            <Route path="/reports/kit-check" element={<KitCheckReport />} />
            <Route
              path="/reports/favorite-teams"
              element={<FavoriteTeamsReport />}
            />
            <Route path="/reports/sales" element={<SalesReport />} />

            {/* Rutas de Paquetes de Videos */}
            <Route path="/video-packages/all" element={<PlanAddonList />} />
            <Route path="/video-packages/:id/edit" element={<PlanAddonUpsertPage />} />
            <Route path="/video-packages/add" element={<PlanAddonUpsertPage />} />

            {/* Ruta catch-all: redirige al dashboard si la ruta no existe */}
            <Route path="*" element={<Dashboard />} />
          </Routes>
        </main>
      </div>
    </Layout>
  );
};

export default Admin;
